import React from 'react';

import classNames from 'classnames';
import styles from './ListAlert.module.scss';

interface ListAlertProps {
	className?: string;
	listHeader?: string;
	isPassword?: boolean;
	errors: string[];
	isFormError?: boolean;
}
// Passwords must have at least:
class ListAlert extends React.Component<ListAlertProps> {
	render() {
		const { errors, className, isPassword, listHeader, isFormError } = this.props;

		if (errors === undefined || errors.length === 0) return null;

		return (
			<div className={classNames({ [styles.passwordAlert]: isFormError }, className)}>
				<span>{isPassword ? 'Please make sure your password:' : listHeader}</span>

				<ul>
					{errors.map(item => (
						<li key={item}>{item}</li>
					))}
				</ul>
			</div>
		);
	}
}

export default ListAlert;
